import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import WeightSlabList from './WeightSlabList'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const WeightSlabTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('weight')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }
  return checkPageAccess(
    pageAccess,
    allPages?.weightSlab,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        {checkPageAccess(
          pageAccess,
          allPages?.weightSlab,
          allCrudNames?.read
        ) && (
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                onClick={(e) => handleTabClick(e, 'weight')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'weight' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Weight Slab
                  <hr />
                </span>
              </Link>
            </div>
            <div className='tab-content p-3'>
              <div
                id='weight'
                className={`tab-pane fade ${
                  activeToggle === 'weight' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'weight' && <WeightSlabList />}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default WeightSlabTabbing
